export enum FormalityTypeEnum {
  creation = 'creation',
  annual = 'annual',
  exceptional = 'exceptional'
}
